import { RedoFulfillmentLocationSchema } from "@redotech/redo-model/fulfillments/fulfillment-location";
import * as z from "zod/v4";

export const getLocationsWithFulfillsFor = {
  name: "getLocationsWithFulfillsFor" as const,
  input: z.object({}),
  output: z.object({ locations: z.array(RedoFulfillmentLocationSchema) }),
};
